import ConfigProvider from './context/config/ConfigProvider';
import UserProvider from './context/user/UserProvider';
import UserDetailProvider from './context/userDetails/UserDetailProvider';
import { HealthProvider } from './context/health/HealthContext';
import { StripeProvider } from './context/stripe/StripeContext';
import SocketProvider from "./context/socket/SocketProvider";
import NotificationProvider from "./context/notifications/NotificationProvider";
import SearchProvider from "./context/search/SearchProvider";
import CraftProvider from "./context/crafts/CraftProvider";
import ArtisanProvider from "./context/artisans/ArtisanProvider";
import BidProvider from "./context/bids/BidProvider";
import StatusProvider from "./context/bookingStatus/StatusProvider";
import ChatProvider from "./context/chat/ChatProvider";
import { FeedProvider } from "./context/feed/FeedProvider";

export default function AppProviders({ children }) {
  return (
    <ConfigProvider>
      <UserProvider>
        <UserDetailProvider>
          <HealthProvider>
            <StripeProvider>
              <SocketProvider>
                <NotificationProvider>
                  <SearchProvider>
                    <CraftProvider>
                      <ArtisanProvider>
                        <BidProvider>
                          <StatusProvider>
                            <FeedProvider>
                              <ChatProvider>
                                {children}
                              </ChatProvider>
                            </FeedProvider>
                          </StatusProvider>
                        </BidProvider>
                      </ArtisanProvider>
                    </CraftProvider>
                  </SearchProvider>
                </NotificationProvider>
              </SocketProvider>
            </StripeProvider>
          </HealthProvider>
        </UserDetailProvider>
      </UserProvider>
    </ConfigProvider>
  );
}
